<template>
  <div id="SelectSeatingAreaMobile">
    <div class="section-selector">
      <b-form-select v-model="optionSelected" id="optionSelector">
        <b-form-select-option value="all">All sections</b-form-select-option>
        <template v-for="(option, i) in seatingData">
          <b-form-select-option
            v-if="option.class !== 'allAreas'"
            :key="'option' + option.class + i"
            :value="option.title"
          >
            {{ option.title }}
          </b-form-select-option>
        </template>
      </b-form-select>
      <div class="select-instructions">
        Select a section to view location on map and additional details &
        <span>benefits!</span>
      </div>
      <div class="select-info" v-if="optionSelected == 'all'">
        <img
          class="map"
          @click="(mapModal = true), (activeMap = seatingData[0].map)"
          :src="seatingData[0].map"
        />
      </div>
      <template v-for="(info, ind) in seatingData">
        <div
          :key="'info' + seatingSection + ind"
          v-if="info.title == optionSelected && optionSelected !== 'all'"
          class="select-info"
        >
          <img
            class="map"
            @click="(mapModal = true), (activeMap = info.map)"
            :src="info.map"
          />
          <div
            class="select-info__title"
            :style="{ 'border-left-color': info.color }"
          >
            {{ info.title }}
          </div>
          <div class="select-info__description" v-if="info.description">
            {{ info.description }}
          </div>
          <div class="select-info__item" v-if="info.heading">
            {{ info.heading }}
          </div>
          <div class="select-info__item" v-if="info.sections">
            <div class="image">
              <img src="@/assets/icons/icon_blue-small_pin-location.svg" />
            </div>
            <p v-html="info.sections"></p>
          </div>
          <div class="select-info__item" v-if="info.capacity">
            <div class="image">
              <img src="@/assets/icons/icon_blue-small_ticket.svg" />
            </div>
            capacity <span>{{ info.capacity }}</span>
          </div>
          <div class="select-info__item" v-if="info.price">
            <div class="image">
              <img src="@/assets/icons/icon_blue-small_dollar-sign.svg" />
            </div>
            <p v-html="info.price"></p>
          </div>
          <div class="select-info__item legal" v-if="info.legal">
            <div class="image" />
            {{ info.legal }}
          </div>
          <div class="select-info__carousel" v-if="info.carousel">
            <b-carousel id="SeatingAreaMobileCarousel" controls>
              <b-carousel-slide
                v-for="(image, inde) in info.carousel"
                :key="'image' + info.class + inde"
                :img-src="image"
              />
            </b-carousel>
          </div>
        </div>
      </template>
    </div>
    <div class="divider" />
    <div class="select-table">
      <div class="select-table__row title-row">
        <div class="item itemTitle"></div>
        <div class="item early-bird">
          <!-- <div class="big">early bird pricing</div>
          <div class="small">Offer ends January 1</div> -->
        </div>
        <div class="item regular">
          <div class="big">2025 group<br />pricing</div>
        </div>
      </div>
      <template v-for="(seat, index) in seatingData">
        <div
          class="select-table__row content-row"
          v-if="seat.class != 'allAreas'"
          :key="seat.class + index"
          :style="{ 'border-left-color': seat.color }"
          :class="[{ active: seat.active }, seat.class]"
        >
          <!-- <div class="item itemTitle" v-if="seat.htmltitle" v-html="seat.htmltitle"></div> -->
          <!-- <div class="item itemTitle" v-else>{{ seat.title }}</div> -->
          <div class="item itemTitle">{{ seat.title }}</div>
          <div class="item early-bird" v-if="seat.earlyBird">
            <div class="light">Starting at</div>
            <div class="early-bird__right">
              ${{ seat.earlyBird }}
              <div class="light">Per Person</div>
            </div>
          </div>
          <div class="item early-bird" v-else></div>
          <div class="item regular only" v-if="seat.regularOnly">
            <div class="only-holder">
              <div class="regularOnly">${{ seat.regularOnly }}</div>
              <div class="light">Per Person</div>
            </div>
          </div>
          <div class="item regular start" v-else-if="seat.regularOnlyStart">
            <div class="light">Starting at</div>
            <div class="regular__right">
              <div class="regularOnly">${{ seat.regularOnlyStart }}</div>
              <div class="light">Per Person</div>
            </div>
          </div>
          <div class="item regular tbd" v-else-if="seat.tbd">
            <div class="only-holder">
              <div class="regularOnly">{{ seat.tbd }}</div>
            </div>
          </div>
          <div class="item regular" v-else>
            <div class="strike">${{ seat.regular }}</div>
            <div class="light">Per Person</div>
          </div>
        </div>
      </template>
    </div>
    <!-- <div class="disclaimer-title">early bird pricing</div>
    <div class="disclaimer-copy first">
      Book your group or place a 50% deposit during the early booking window and
      take advantage of the lowest possible group pricing during the 2022
      season.
    </div> -->
    <div class="disclaimer-copy">
      All Texas Rangers tickets are subject to dynamic pricing - supply and
      demand causes pricing to fluctuate. The price you lock in will be honored
      until two weeks out from your game date. Additional tickets purchased
      after that date will be subject to dynamic pricing changes.
      <br /><br />
      All Texas Rangers Groups Tickets are digital. To print tickets, additional
      fees apply - $25 for groups 15-99; $50 for groups 100+.
      <br /><br />
      <span
        >The resale of group tickets is strictly prohibited and could result in
        the loss of group ticket privileges.</span
      >
      <br /><br />
      *Applicable fees and taxes to be added at time of purchase.
    </div>
    <div class="mapModal" :class="{ active: mapModal }">
      <img
        class="close"
        @click="mapModal = false"
        src="@/assets/images/close.svg"
      />
      <img class="mapImage" :src="activeMap" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectSeatingAreaMobile",
  props: ["seatingData", "seatingSection"],
  data() {
    return {
      optionSelected: "all",
      mapModal: false,
      activeMap: null,
    };
  },
  mounted() {
    // if (this.seatingSection == 'party') {
    //   this.optionSelected = "ALL EXCLUSIVE PARTY AREAS"
    // } else {
    //   this.optionSelected = "all general group seating areas"
    // }
  },
};
</script>

<style lang="scss" scoped>
#SelectSeatingAreaMobile {
  display: flex;
  flex-direction: column;
  width: 100%;
  .select-instructions {
    font-family: Gotham;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0;
    margin: 24px 0;
    span {
      font-weight: bold;
    }
  }
  .select-info {
    display: flex;
    flex-direction: column;
    width: 100%;
    .map {
      width: 100%;
      object-fit: contain;
      border-radius: 8px;
      cursor: pointer;
    }
    &__title {
      font-family: BertholdCondensed;
      font-weight: 700;
      font-size: 25px;
      line-height: 23px;
      color: #ffffff;
      text-align: left;
      text-transform: uppercase;
      padding-left: 16px;
      margin: 52px 0 13px 0;
      border-left-width: 4px;
      border-left-style: solid;
    }
    &__description {
      font-family: Gotham;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0;
      text-align: left;
      color: #ffffff;
      margin-bottom: 23.81px;
    }
    &__item {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 12px;
      font-family: BertholdCondensed;
      font-weight: 700;
      font-size: 15px;
      line-height: 16px;
      letter-spacing: 0;
      text-align: left;
      color: #ffffff;
      text-transform: uppercase;
      .image {
        width: 15px;
        margin-right: 14.62px;
        img {
          object-fit: contain;
        }
      }
      p {
        font-family: BertholdCondensed;
        font-weight: 700;
        font-size: 15px;
        line-height: 16px;
        letter-spacing: 0;
        text-align: left;
        color: #ffffff;
        margin-bottom: 0;
        text-transform: uppercase;
        span {
          color: #259ef3;
        }
      }
      &.legal {
        font-family: Gotham;
        font-size: 10px;
        line-height: 17px;
        font-weight: normal;
        text-align: left;
        color: #ffffff;
        text-transform: none;
        margin-top: -5px;
      }
    }
  }
  .divider {
    height: 1px;
    width: 100%;
    background-color: #ffffff;
    margin: 50.5px 0 16px 0;
  }
  .select-table {
    display: flex;
    flex-direction: column;
    width: 100%;
    &__row {
      display: flex;
      flex-direction: row;
      .item {
        &.itemTitle {
          flex: 1;
        }
        &.early-bird {
          flex: 1;
        }
        &.regular {
          flex: 2;
        }
      }
      &.title-row {
        margin-bottom: 16px;
        padding: 0 24px 0 27px;
        .item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-end;
          color: #ffffff;
          .big {
            font-family: BertholdCondensed;
            font-size: 15px;
            letter-spacing: 0;
            font-weight: 700;
            line-height: 16px;
            text-transform: uppercase;
          }
          .small {
            font-family: Gotham;
            font-weight: 700;
            font-size: 10px;
            line-height: 17px;
            letter-spacing: 0;
          }
        }
      }
      &.content-row {
        border-left-width: 3.01px;
        border-left-style: solid;
        margin-bottom: 3px;
        padding: 17px 24px 17px 27px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 0 4px 4px 0;
        backdrop-filter: blur(5px);
        &.allAreas {
          border-left: none;
        }
        .item {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: flex-start;
          &.itemTitle {
            justify-content: flex-start;
            font-family: BertholdCondensed;
            font-family: 700;
            font-size: 15px;
            letter-spacing: 0;
            line-height: 16px;
            color: #ffffff;
            text-align: start;
            text-transform: uppercase;
          }
          &.early-bird {
            color: #ffffff;
            .light {
              font-family: Gotham;
              font-weight: 300;
              font-size: 10px;
              line-height: 17px;
              letter-spacing: 0;
              margin-right: 15px;
            }
            &__right {
              display: flex;
              flex-direction: column;
            }
          }
          &.regular {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-family: BertholdCondensed;
            font-weight: 700;
            font-size: 15px;
            letter-spacing: 0;
            line-height: 16px;
            color: #ad2f1e;
            .strike {
              text-decoration: line-through;
            }
            .regularOnly {
              color: #ffffff;
            }
            &.tbd {
              align-items: flex-end;
              padding-right: 17px;
            }
            .light {
              font-family: Gotham;
              font-weight: 300;
              font-size: 10px;
              line-height: 17px;
              letter-spacing: 0;
              color: #ffffff;
              text-decoration: none;
            }
            &.start {
              flex-direction: row;
              justify-content: flex-end;
              .light {
                margin-right: 8px;
              }
            }
            &.only {
              align-items: flex-end;
              .only-holder {
                display: flex;
                flex-direction: column;
                align-items: center;
              }
            }
            .regular__right {
              display: flex;
              flex-direction: column;
              align-items: center;
              .light {
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
  .disclaimer-title {
    font-family: BertholdCondensed;
    font-weight: 700;
    font-size: 15px;
    line-height: 16px;
    letter-spacing: 0;
    color: #ffffff;
    text-transform: uppercase;
    margin: 16px 0 8px 0;
    text-align: left;
  }
  .disclaimer-copy {
    font-family: Gotham;
    font-weight: 300;
    font-size: 10px;
    line-height: 17px;
    letter-spacing: 0;
    color: #c7c7c7;
    text-align: left;
    margin-top: 16px;
    span {
      font-weight: 500;
      font-style: italic;
      color: #c7c7c7;
      margin: 0;
    }
    &.first {
      padding-bottom: 20px;
      margin-bottom: 16px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.25);
    }
  }
  .mapModal {
    position: fixed;
    top: 53.3281px;
    left: 0;
    height: calc(100vh - 53.3281px);
    max-height: 0;
    width: 100vw;
    overflow: hidden;
    background: #f8f8f8;
    z-index: 9999;
    transition: all 0.3s ease-in-out;
    &.active {
      max-height: calc(100vh - 53.3281px);
    }
    .close {
      position: absolute;
      top: 35px;
      right: 35px;
      cursor: pointer;
    }
    .mapImage {
      height: calc(100vh - 53.3281px);
      width: 100vw;
      object-fit: contain;
    }
  }
}
</style>

<style lang="scss">
#SelectSeatingAreaMobile {
  .content-row {
    .early-bird {
      font-family: BertholdCondensed;
      font-weight: 700;
      font-size: 15px;
      line-height: 16px;
      letter-spacing: 0;
      color: #ffffff;
    }
  }
  span {
    color: #259ef3;
    margin-left: 5px;
  }
}
#optionSelector {
  width: 100%;
  min-height: 50px;
  border: 1px solid #040c18;
  // background-attachment: linear-gradient(180deg, #FFFFFF 0%, #E8E8E8 98.23%);
  background-image: url("~@/assets/icons/icon_arrow-karet.svg");
  background-position-x: 97%;
  padding: 14px 24px 18px 24px;
  font-family: Gotham;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0;
  color: #040c18;
  text-transform: uppercase;
  @media (max-width: $sm) {
    background-position-x: 95%;
  }
}
#SeatingAreaMobileCarousel {
  border-radius: 5px;
  overflow: hidden;
  .carousel-control-next-icon {
    background-image: url("~@/assets/icons/icon_white-circle-black-arrow.svg");
    transform: rotate(180deg);
    margin-right: -15px;
  }
  .carousel-control-prev-icon {
    background-image: url("~@/assets/icons/icon_white-circle-black-arrow.svg");
    margin-left: -15px;
  }
  .carousel-control-next-icon,
  .carousel-control-prev-icon {
    width: 43.02px;
    height: 43.02px;
  }
  .carousel-control-next,
  .carousel-control-prev {
    width: 76.83px;
    opacity: 1;
  }
  .carousel-control-next {
    background: linear-gradient(
      270deg,
      rgba(4, 12, 24, 0.6) 0%,
      rgba(4, 12, 24, 0) 100%
    );
  }
  .carousel-control-prev {
    background: linear-gradient(
      270deg,
      rgba(4, 12, 24, 0) 0%,
      rgba(4, 12, 24, 0.6) 100%
    );
  }
}
</style>
